import styled from 'styled-components';
const ParentWaitingWrapper   = styled.div`
height:100%;
.mt-40{
    margin-top:40px;
}
.parentWaiting {
    .page-header  {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: var(--page-header-width);
        color: var(--page-header-txtColor);
        background: var(--page-header-bgColor);
        font-family:"open sans", sans-serif;
        z-index:999;
        min-height:90px;
        nav{
        min-height:90px;
        display: -webkit-box;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
        // min-height: 100%;
        margin:0;
        padding:20px;
        }
        .scrollable-content{
            padding-bottom:90px;
        }
        .section-title{
            font-size: 14px;
            color: #ffffff;
            font-weight: 600;
            text-transform: uppercase;
            padding: 0 0 10px;
        }
        .user__not__available{
            width: 235px;
            height: 26px;
            font-family: OpenSans;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: italic;
            line-height: 1.36;
            letter-spacing: normal;
            text-align: left;
            color: #b2b9d6;
        }          

        .user__profile{
            font-family: 'Open Sans',sans-serif;
            margin-left: auto;
            position: relative;
            margin-top:10px;
            .thumb-inner{
                cursor: pointer;
                display: -webkit-box;
                display: -moz-box;
                display: -ms-flexbox;
                display: -webkit-flex;
                display: flex;
                -webkit-align-items: center;
                -webkit-box-align: center;
                -webkit-flex-align: center;
                align-items: center;
                
                h1{
                    font-family: 'Open Sans',sans-serif;
                    font-size: 14px;
                    font-weight:700;
                    color:#fff;
                    margin-left:15px;
                }
                img{
                    width: 40px;
                    height: 40px;
                    border-radius:50%;
                }
                .thumb-initials{
                    background: #B4BBD6;
                    width: 50px;
                    height: 50px;
                    -webkit-text-decoration: none;
                    text-decoration: none;
                    display: block;
                    border-radius: 50%;
                    color: #fff;
                    line-height: 50px;
                    cursor: pointer;
                    text-align: center;
                }
            }
            .status{
                font-size: 10px;
                background: #f6c933;
                width: 130px;
                color:#344177;
                text-align: center;
                border-radius:8px;
                padding: 5px;
                position: absolute;
                font-weight:600;
                left: 53px;
                bottom: -20px;
            }
        }

        h3{
            font:"open sans", sans-serif;
            color:#4eb0de;
            margin:0;
            padding:7px 0 0;
            font-size:14px;
            text-transform:uppercase;
            font-weight:300;
        }
        .logo {
            display: block;
            max-width: 120px;
            margin: 0;
          }
         
            .patient-queue{
                padding:20px;
                >h1{
                font-size:14px;
                color:#ffffff;
                font-weight:600;
                text-transform:uppercase;
                padding:0 0 10px;
                }
                }
            }
    
      }

      .participantList{
        padding:0 20px 20px;
       >ul{
         li{
           padding:0 0 60px;
           .participantList_status{
             display:flex;
             align-items:center;
             .participantList_thumb{
               margin-right:10px;
                >img{
                  min-width:40px;
                  width: 40px;
                  height: 40px;
                  border-radius: 50%;
                  cursor: pointer;
                }
             }
             .participant_rightpan{
               position:relative;
               width:100%;
              .participantName{
                font-size:14px;
                color:#ffffff;
                font-weight:normal;
                text-transform:capitalize;
                font-weight:700;
                margin: 0;
                padding: 0;
                line-height: normal;
             }
             .user-status{
              position:absolute;
              top: 25px;
              border: solid 1px #f6c933;
              padding: 5px 15px;
              color: #344177;
              font-weight: bold;
              font-size: 0.75rem;
              border-radius: 10px;
              margin-right: 10px;
              text-transform: uppercase;
              letter-spacing: normal;
              line-height: normal;
              &.on-other-call{
                background:#f6c933;
                border-color:#f6c933;
                color:#344177;
              }
              &.available{
                background:#8ec93d;
                border-color:#8ec93d;
                color:#344177;
              }
              &.busy{
                background:#d05353;
                border-color:#d05353;
                color:#344177;
              }
              &.not-available-yet{
                background:#b2b9d6;
                border-color:#b2b9d6;
                color:#344177;
              }
            }

             }
             
           }
         }
       }
    }

.page-content{
      .call-waiting-msg{
        //   text-align:center;
        //   padding:150px 0 0;
        text-align: center;
        height: 100%;
        display: flex;
        flex-direction:column;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 0;
        left: 0;
        >h1{
            color:#b2b9d6;
            font-weight:600;
            font-size:25px;
            margin-top: auto;
        }
        
        .camera-permission{
          width: 500px;
          color: #b2b9d6;
          font-weight: 500;
          font-size: 20px;
          margin-top: auto;
          line-height: 28px;
          .moreinfo{
            font-family: "open sans",sans-serif;
            cursor: pointer;
            background-color: #4eb0de;
            margin: auto;
            width: 130px;
            font-size: 0.75rem;
            border: 0;
            border-radius: 10px;
            display: block;
            text-transform: uppercase;
            text-align: center;
            color: #ffffff;
            font-weight: bold;
            padding: 5px 10px;
            margin-top: 10px;
          }
        }
        
        .exitvideoRoom_btn{
          font-family: "open sans", sans-serif;
          background:#d05353;
          width: 276px;
          color:#fff;
          height: 36px;
          font-size: 14px;
          line-height: 1;
          font-weight: bold;
          border-radius: 10px;
          text-transform: uppercase;
          border: 0;
          margin-top:auto;
          margin-bottom:60px;
        }
      }
    }
}


`;


export default (ParentWaitingWrapper);